import { render } from "./ModulesFormScreen.vue?vue&type=template&id=8c405dc8"
import script from "./ModulesFormScreen.vue?vue&type=script&lang=js"
export * from "./ModulesFormScreen.vue?vue&type=script&lang=js"

import "./ModulesFormScreen.vue?vue&type=style&index=0&id=8c405dc8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__